import { CraftAttributeValue } from "@components/photo-lib/photo-lib-list/model/craft-attribute-value";
import { JsonProperty, Serializable } from "typescript-json-serializer";

@Serializable()
export class PhotoLibItemRef {
    @JsonProperty()
    photoLibId: number;
    @JsonProperty()
    photoLibName: string;
    @JsonProperty()
    probability: number;
    @JsonProperty()
    totalCount: number;
}


export interface IPhotoLibItemRef {
    photoLibId?: number;
    photoLibName: string;
    probability: number
    totalCount?: number
    craftAttributeValues?: Array<CraftAttributeValue>
    isSpecialCraft?: boolean;
    isLocalEffects?: boolean;
}
@Serializable()
export class RuleItem {
    @JsonProperty()
    id: number;
    @JsonProperty({ type: PhotoLibItemRef })
    photoLibItems: PhotoLibItemRef[];
    @JsonProperty()
    ratio: number;
    @JsonProperty()
    sortOrder?: number;
}


export interface IRuleItem {
    id: number;
    photoLibItems: IPhotoLibItemRef[];
    ratio: number;
    sortOrder?: number
}



@Serializable()
export class ViewContentRule {
    @JsonProperty()
    id: number;
    @JsonProperty({ type: RuleItem })
    rangeItems: RuleItem[];
    @JsonProperty()
    smvId: string;
    @JsonProperty()
    strategy: string;
}




export interface IViewContentRule {
    id: number;
    rangeItems: IRuleItem[];
    smvId: string;
    strategy: "percent" | "fix";
}

// 随机设计规则列表
export interface IVeiwContentRuleList {
    qtyRangeContentRules: IViewContentRule[];
}




